import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ShowOrHideComponent } from '../../models/showOrHideComponent';
import { ShowOrHideSpinner } from '../../models/showOrHideSpinner';
import { DownloaderService } from '../../services/downloader.service';
import { ErrorsService } from '../../services/errors.service';
import { SpinnerService } from '../../services/spinner.service';
import { VerificationService } from '../../../verification/services/verification.service';
import { NavigationStart, Router } from '@angular/router';
import { PolicyMessages } from '../../models/component-messages/policy-messages';
import { TranslateService } from '@ngx-translate/core';
import { ToastMessages } from '../../models/component-messages/toast-messages';

declare var require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-policy-resp',
  templateUrl: './policy-resp.component.html',
  styleUrls: ['./policy-resp.component.scss']
})
export class PolicyRespComponent extends ShowOrHideSpinner implements OnInit, ShowOrHideComponent {

  public policyMessages = new PolicyMessages();
  public toastMessages = new ToastMessages();
  public error = false;
  public moduleName: string;
  private policyVerificationFileName = 'Politique_Verification-v0.1.pdf';
  private policySignatureFileName = 'Politique_Signature_v1_2.pdf';
  private sessionStorageKeyOfPolicy = 'policyContent';

  constructor(private verificationService: VerificationService,
              private downloaderService: DownloaderService,
              private toastr: ToastrService,
              private errorsService: ErrorsService,
              private spinnerService: SpinnerService,
              private router: Router,
              private translate: TranslateService) {
    super();
  }

  public showComponent() {
    return this.isSpinnerNotInProgress(this.spinnerService) && !this.errorsService.error;
  }

  public ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url.toString().trim() === '/verifier/process') {
          this.moduleName = this.policyMessages.verifySignature;
        } else if (event.url.toString().trim() === '/signer') {
          this.moduleName = this.policyMessages.createSignature;
        }
      }
    });
  }

  public getPolicy() {
    this.error = false;
    const verificationPolicy = sessionStorage.getItem(this.sessionStorageKeyOfPolicy);

    if (this.moduleName === this.policyMessages.verifySignature) {
      if (verificationPolicy) {
        this.downloaderService.downloadFile(this.policyVerificationFileName, verificationPolicy, 'pdf');
      } else {
        this.verificationService.policy().subscribe(data => {
            sessionStorage.setItem(this.sessionStorageKeyOfPolicy, data.base64Policy);
            this.downloaderService.downloadFile(this.policyVerificationFileName, data.base64Policy, 'pdf');
          },
          (err) => {
            this.error = true;
            this.toastr.warning(this.translate.instant(this.toastMessages.warningContent), this.translate.instant(this.toastMessages.warningTitle), {
              positionClass: 'toast-bottom-right'
            });
          });
      }
    }
    if (this.moduleName === this.policyMessages.createSignature) {
      this.downloadPdf();
    }
  }

  private downloadPdf() {
    const pdfUrl = './assets/pdf/AIFE_Politique_Signature_v1_2.pdf';
    FileSaver.saveAs(pdfUrl, this.policySignatureFileName);
  }
}
